import {
  VuexModule, Module, Mutation, Action,
} from 'vuex-module-decorators';
import store from '@/store';
import Authority from './authority.entity';
import AuthorityService from './authority.service';

@Module({ dynamic: true, name: 'authoritytStore', store })
export default class AuthorityStore extends VuexModule {
  private static authority = new Authority([]);

  private static fetched = false;

  static fetchedAuthority(): Promise<Authority> {
    if (!this.fetched) {
      return AuthorityService
        .authorities()
        .then(response => this.handleFetchAuthorities(response));
    }
    return Promise.resolve(this.authority);
  }

  static hasAuthority(authorities: string[]): Promise<boolean> {
    return this.fetchedAuthority()
      .then(authority => authority.hasAuthorities(authorities));
  }

  static isAdministrator(): Promise<boolean> {
    return this.fetchedAuthority()
      .then(authority => authority.isAdministrator());
  }

  static isManager(): Promise<boolean> {
    return this.fetchedAuthority()
      .then(authority => authority.isManager());
  }

  private static handleFetchAuthorities(response: string[]) {
    this.fetched = true;
    this.authority = new Authority(response);
    return this.authority;
  }
}
